import * as action from "../reducers/articleReducer";
import axios, { authHeader } from "../../services/HTTPService";
const API_URL = process.env.REACT_APP_API_URL;

export const reOrder = async (dispatch, body, filterParams) => {
  return axios
    .put(API_URL + `/api/articles/reOrder`, body, { headers: authHeader() })
    .then(({ data }) => {
      console.log('data', filterParams)
      fetchAll(dispatch, filterParams);
    })


    .catch((error) => {
      dispatch(
        action.setArticleError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const fetchAll = async (
  dispatch,
  {
    fieldTofilter,
    filter,
    fieldToSort,
    sortDirection,
    page,
    pageSize,
    memberFilters,
  } = {
    fieldTofilter: "title",
    filter: "",
    fieldToSort: "order",
    sortDirection: "desc",
    page: 1,
    pageSize: 10,
    memberFilters: { all: true, members: [], groups: [] },
  }
) => {
  dispatch(action.setListLoading(true));

  return axios
    .get(API_URL + `/api/articles/backoffice/search`, {
      headers: authHeader(),
      params: {
        fieldTofilter,
        filter,
        fieldToSort,
        sortDirection,
        page,
        pageSize,
        memberFilters,
      },
    })
    .then(({ data }) => {
      const meta = data?.meta;
      dispatch(action.setArticleList({ data }));
      dispatch(action.setMetadata({ meta }));
      dispatch(action.setListLoading(false));
    })
    .catch((error) => {
      dispatch(
        action.setArticleError({ error: error?.response?.data?.error?.message })
      );
      dispatch(action.setListLoading(false));
    });
};

export const fetchDetails = async (dispatch, id) => {
  if (!id) return;
  return axios
    .get(API_URL + `/api/articles/${id}`, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setArticleDetail({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setArticleError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const create = async (dispatch, body) => {
  return axios
    .post(API_URL + "/api/articles", body, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setArticle({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setArticleError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const update = async (dispatch, id, body) => {
  return axios
    .put(API_URL + `/api/articles/${id}`, body, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setArticle({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setArticleError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const remove = async (dispatch, id, params) => {
  return axios
    .delete(API_URL + `/api/articles/${id}`, { headers: authHeader() })
    .then(async () => {
      await fetchAll(dispatch, params);
    })
    .catch((error) => {
      dispatch(
        action.setArticleError({ error: error?.response?.data?.error?.message })
      );
    });
};
